import ReferralLayout from '../views/referrals/Index'
import ReferralList from '../views/referrals/List'
import ReferralEdit from '../views/referrals/Edit'
import ReferralShow from '../views/referrals/Show'
import Permissions from '@/permissions'

export const referralRouters = {
  path: 'referral',
  component: ReferralLayout,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.referral.manage],
    groups: 'referral'
  },
  children: [
    {
      path: '',
      name: 'Referral',
      component: ReferralList,
      meta: {
        permissions: [Permissions.backend.referral.list],
        groups: 'referral',
        breadcrumb: [
          {
            name_en: 'Referral',
            name_km: 'ណែនាំ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'edit/:id',
      name: 'ReferralEdit',
      component: ReferralEdit,
      meta: {
        permissions: [Permissions.backend.referral.list],
        groups: 'referral',
        breadcrumb: [
          {
            name_en: 'Referral',
            name_km: 'ណែនាំ'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'show/:id',
      name: 'ReferralShow',
      component: ReferralShow,
      meta: {
        permissions: [Permissions.backend.referral.show],
        groups: 'referral',
        breadcrumb: [
          {
            name_en: 'Referral',
            name_km: 'ណែនាំ'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    }
  ]
}
